// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-form[data-v-7b3040be]{padding:10px 70px}.upperinput[data-v-7b3040be]{text-transform:uppercase}.upperinput[data-v-7b3040be]:-moz-placeholder-shown{text-transform:none}.upperinput[data-v-7b3040be]:-ms-input-placeholder{text-transform:none}.upperinput[data-v-7b3040be]:placeholder-shown{text-transform:none}@media only screen and (max-width:600px){.el-form[data-v-7b3040be]{padding:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
